<template>
  <el-dialog
    title="添加考生"
    :visible.sync="dialogVisibleObj.addExamineeShow"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="handleBeforeClose"
  >
    <!-- 添加考生弹窗 -->
    <div class="examin_mian">
      <div class="examin_head">
        <el-form
          :label-position="labelPosition"
          label-width="80px"
          :model="formLabelAlign"
          ref="formLabelAlign"
        >
          <el-form-item label="姓名：" prop="name">
            <el-input
              v-model.trim="formLabelAlign.name"
              placeholder="请输入考生姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号：" prop="account">
            <el-input
              v-model.trim="formLabelAlign.account"
              placeholder="请输入考生账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="科室：" prop="department">
            <el-select
              v-model="formLabelAlign.department"
              clearable
              filterable
              multiple  
              collapse-tags
              placeholder="全部"
              @change="searchChang()"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in keshioptions"
                :key="item.DepartmentID"
                :label="item.DepartmentName"
                :value="item.DepartmentName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="职称：" prop="region">
            <el-select
              v-model="formLabelAlign.region"
              placeholder="全部"
              multiple  
              collapse-tags
              @change="searchChang()"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in zhichengoptions"
                :key="item.PTitle"
                :label="item.PTitle"
                :value="item.PTitle"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职位：" prop="position">
            <el-select
              v-model="formLabelAlign.position"
              placeholder="全部"
              multiple  
              collapse-tags
              @change="searchChang()"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in zhiweioptions"
                :key="item.Position"
                :label="item.Position"
                :value="item.Position"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="分组：" prop="department">
            <el-select
              v-model="formLabelAlign.gourpId"
              clearable
              multiple  
              collapse-tags
              placeholder="全部"
              @change="searchChang()"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in gourpoptions"
                :key="item.groupID"
                :label="item.groupName + '（' + item.count + '人）'"
                :value="item.groupID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="query_btn">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="searchbtn"
            @click="searchBtn"
            >搜索</el-button
          >
          <el-button
            icon="el-icon-refresh"
            class="searchbtn sonbtn"
            @click="resetForm('formLabelAlign')"
            >重置</el-button
          >
        </div>
      </div>
      <!-- 表格 -->
      <div class="examinee_form" v-loading="loading">
        <p class="">
          已选{{ determineArr.length }}人，科室{{ this.unique() }}个
        </p>
        <el-table
          ref="multipleTable"
          :data="getData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
          @row-click="StepsListRowClick"
          :header-cell-style="{
            'background-color': '#EEEEEE',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column type="selection" width="80"></el-table-column>
          <el-table-column label="序号" width="80px">
            <template slot-scope="scope">
              {{ scope.$index + 1 + currentPage3 * pageSize }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="pageSize"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelClick">取 消</el-button>
      <el-button type="primary" @click="certainClick">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addFormColumns } from "@/state/candidate";
import getstudentlist from "@/api/questionbank";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      dialogVisibleObj: {
        addExamineeShow: false, // 添加考生
      },
      labelPosition: "right",
      formLabelAlign: {
        name: "", //考生姓名
        account: "", //考生账号
        department: "", //科室
        gourpId: "", //分组id
        region: "", //职称
        position: "", //职位
      },
      getDataCondition: {
        name: "", //考生姓名
        account: "", //考生账号
      },
      keshioptions: [], //全部科室的列表
      zhichengoptions: [], //全部职称的列表
      zhiweioptions: [], // 职位
      gourpoptions: [], // 分组
      formColumns: [], // 表头
      getData: [], // 数据
      isslectstudentnum: "", //选中考生总人数
      loading: false,
      currentPage3: 0, //  当前页数
      currentPage1: 1, //绑定的页数。
      pageSize: 5,
      total: 100,
      queryType: true, // 查询type 防止再次传参请求重置查询列表
      pagesizesarr: [5, 10, 20, 50, 100],
      determineArr: [], // 最终确定发送的考生名单
      selectList: [],
      historyList: [], //历史的列表
    };
  },
  methods: {
    init(data) {
      this.determineArr = data;
      this.selectList = data.map((e) => e.UserID);
      this.historyList = data;
      this.dialogVisibleObj.addExamineeShow = true;
      this.getStudentlist();
    },
    // 弹窗关闭前触发
    handleBeforeClose(done) {
      this.cancelClick();
      done();
    },
    // 取消
    cancelClick() {
      this.queryType = true;
      this.dialogVisibleObj.addExamineeShow = false;
    },
    // 确定考生
    certainClick() {
      this.$emit("finallyArr", this.determineArr);
      this.dialogVisibleObj.addExamineeShow = false;
    },
    // chang搜索
    searchChang() {
      this.loading = true;
      this.getStudentlist();
    },
    // 搜索
    searchBtn() {
      this.currentPage3 = 0;
      this.loading = true;
      if (this.formLabelAlign.name) {
        this.getDataCondition.name = this.formLabelAlign.name;
      } else {
        this.getDataCondition.name = "";
      }
      if (this.formLabelAlign.account) {
        this.getDataCondition.account = this.formLabelAlign.account;
      } else {
        this.getDataCondition.account = "";
      }
      this.getStudentlist();
    },
    // 重置
    resetForm(formLabelAlign) {
      this.loading = true;
      this.getDataCondition.name = "";
      this.getDataCondition.account = "";
      this.formLabelAlign.gourpId = "";
      this.$refs[formLabelAlign].resetFields();
      this.getStudentlist();
    },
    // 去重
    unique() {
      let departArr = this.determineArr.map((item) => {
        return item.DepartmentName;
      });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },
    // 获取考生列表
    async getStudentlist() {
      let student = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        UserName: this.getDataCondition.account,
        RealName: this.getDataCondition.name,
        Position: JSON.stringify(this.formLabelAlign.position),
        department: JSON.stringify(this.formLabelAlign.department),
        PTitle: JSON.stringify(this.formLabelAlign.region),
        startTime: "",
        groupID: JSON.stringify(this.formLabelAlign.gourpId),
        endTime: "",
        pageIndex: JSON.stringify(this.currentPage3), //开始页
        pageShow: this.pageSize, //条数
      };
      this.loading = true;
      const { data } = await getstudentlist.getseekAndCreateExam(student);
      if (data.Status == 200) {
        this.getData = data.Data[0];
        this.total = data.Data[4][0].dataPageCount;
        this.getData = this.getData.map((item) => {
          for (let ztiem in item) {
            if (item[ztiem] === "" || item[ztiem] === null) {
              item[ztiem] = "未设置";
            }
          }
          item.Birthday1 = this.$moment(item.BeginTime).format(
            "YYYY/MM/DD HH:mm"
          );
          return item;
        });
        if (this.queryType) {
          this.keshioptions = data.Data[1];
          this.zhichengoptions = data.Data[3];
          this.zhiweioptions = data.Data[2];
          this.queryType = false;
          this.getStudentGoup(student); // 获取考生分组查询列表数组
        }
        this.historyList = JSON.parse(JSON.stringify(this.determineArr));
        setTimeout(() => {
          this.getData.forEach((e) => {
            if (this.selectList.includes(e.UserID)) {
              this.historyList = this.historyList.filter(
                (item) => item.UserID != e.UserID
              );
              this.$refs.multipleTable.toggleRowSelection(e, true);
            }
          });
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.data);
      }
    },
    // 获取查询列表组
    async getStudentGoup(p) {
      const { data } = await getstudentlist.getstudentlist(p);
      if (data.Status == 200) {
        this.gourpoptions = data.Data.data;
      } else {
        this.$message.error(data.data);
      }
    },
    // 表格选中
    handleSelectionChange(val) {
      let a = {};
      this.determineArr = this.historyList.concat(val).filter((item) => {
        if (a[item.UserID]) {
          return false;
        } else {
          a[item.UserID] = "2";
          return true;
        }
      });
      this.selectList = Object.keys(a).map((item) => Number(item));
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getStudentlist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      this.currentPage3 = val - 1;
      this.getStudentlist();
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
  },
  props: ["historyArr"],
  mounted() {},
  created() {
    this.formColumns = addFormColumns;
  },
};
</script>

<style lang="scss" scoped>
.title_box {
  padding-bottom: 9px;
  margin-bottom: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 19px;
  color: #333333;
  border-bottom: 1px solid #abd7ff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
::v-deep .dialog-footer {
  margin-bottom: 30px;
}
::v-deep.el-dialog__footer {
  justify-content: center !important;
  margin-bottom: 50px;
}
.el-dialog__footer span > button {
  margin-top: 10px;
  width: 103px;
  height: 42px;
}
::v-deep .el-dialog {
  width: 1400px;
  // height: 688px;
  // overflow-y: scroll;
  border-radius: 5px 5px 0px 0px;
}
::v-deep .el-dialog__header {
  padding: 0px 24px;
}
.examin_head {
  padding: 30px 24px 10px 10px;
  display: flex;
  .el-form {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 160px;
    }
    .el-select {
      width: 140px;
    }
  }
  .query_btn {
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}
.examinee_form {
  padding: 0px 20px 0px 34px;
  p {
    margin-bottom: 16px;
  }
}
::v-deep .delete_view .el-dialog {
  width: 496px;
  height: 546px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  line-height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  .el-dialog__title {
    color: #fff;
    letter-spacing: 4px;
  }
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    &:nth-child(2) {
      margin-left: 90px;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__body-wrapper {
  height: 240px;
  overflow-y: scroll;
  position: relative;
  scrollbar-face-color: none !important;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    //  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
  & ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
}
::v-deep .el-table__header-wrapper {
  position: sticky;
  top: 0;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
}
</style>